import AddForTag from './AddForTag';

const forTag = {
  id: 'for',
  AddTag: AddForTag
};

export default forTag;
